module.exports = __webpack_public_path__ + "static/media/Silcoon_gaussian2.e84043cd.png";